import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes:Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    redirect: '/marketing/transfer-page',
    // component: () => import('../views/home'),
  },
  {
    path: '/marketing/poster',
    name: 'MarketingPoster',
    component: () => import('../views/marketing/poster'),
  },
  {
    path: '/marketing/transfer-page',
    name: 'MarketingTransferPage',
    component: () => import('../views/marketing/transfer-page'),
  },
  // {
  //   path: '/demo',
  //   name: 'Demo',
  //   component: () => import('../views/demo'),
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('../views/about/index.vue'),
  // },
  {
    path: '/:pathMatch(.*)',
    name: 'pageNotFound',
    redirect: '/marketing/transfer-page',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
